import { render, staticRenderFns } from "./ListOpponents.vue?vue&type=template&id=8f7d47e4&scoped=true&lang=pug&"
import script from "./ListOpponents.vue?vue&type=script&lang=js&"
export * from "./ListOpponents.vue?vue&type=script&lang=js&"
import style0 from "./ListOpponents.vue?vue&type=style&index=0&id=8f7d47e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7d47e4",
  null
  
)

export default component.exports